import { withApollo } from "react-apollo";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import { withNotificationContext } from "js/notification-context";
import { compose } from "recompose";
import { styles } from "./styles.js";
import Notificaciones from "./Notificaciones";

const enhance = compose(
  withApollo,
  withRouter,
  withNotificationContext,
  withStyles(styles)
);

export default enhance(Notificaciones);
